import React from 'react';
import { FormHelperText, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next'; // ✅ Import useTranslation

export const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => {
    const { t } = useTranslation(); // ✅ Get translation function

    return (
        <div>
            <TextField
                {...input}
                select
                label={label}
                fullWidth
                onChange={(event) => input.onChange(event.target.value)}
                {...custom}
            >
                {children}
            </TextField>
            {touched && error && (
                <FormHelperText error>{t(error)}</FormHelperText> // ✅ Translate the error key
            )}
        </div>
    );
};


//import React from 'react';
//import { FormHelperText, TextField } from '@material-ui/core';

//export const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
//    <div>
//        <TextField
//            {...input}
//            select
//            label={label}
//            fullWidth
//            onChange={(event, index, value) => input.onChange(event.target.value)}
//            children={children}
//            {...custom}
//            {...touched && error ? <span>{error}</span> : false}
//        />
//        <FormHelperText error={!!error && !!touched}>{touched && error}</FormHelperText>
//    </div>
//)